import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "BannerWidget BannerWidgetBackground BestFitBannerWrapper js-Widget" }
const _hoisted_2 = { class: "DesktopWidget" }
const _hoisted_3 = { class: "HeadingWrapper" }
const _hoisted_4 = { class: "ResultHeading" }
const _hoisted_5 = { class: "ScoreAndImageContainer" }
const _hoisted_6 = ["data-study-id"]
const _hoisted_7 = { class: "MobileWidget" }
const _hoisted_8 = { class: "MobileContent" }
const _hoisted_9 = { class: "ScoreAndImageContainer" }
const _hoisted_10 = { class: "TextAndButtonContainer" }
const _hoisted_11 = { class: "ResultHeading" }
const _hoisted_12 = { class: "ResultSubHeading" }
const _hoisted_13 = ["data-study-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoreGradientCircle = _resolveComponent("ScoreGradientCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.displayScore) + "! ", 1 /* TEXT */),
          _createTextVNode(" " + _toDisplayString(_ctx.displayScoreText), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ScoreGradientCircle, {
          score: _ctx.bestFitScore,
          type: _ctx.scoreTypeGradientCircle
        }, null, 8 /* PROPS */, ["score", "type"])
      ]),
      (_ctx.showWishlistButton)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["WishlistButton", _ctx.isLargeScreen ? 'Small' : '']),
            "data-study-id": _ctx.studyId,
            "data-button-type": "study_header",
            "data-button-location": "study_banner",
            "data-button-class": "DriverButton"
          }, null, 10 /* CLASS, PROPS */, _hoisted_6))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["DriverButton Blue", _ctx.isLargeScreen ? 'Small' : '']),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args)))
          }, _cache[2] || (_cache[2] = [
            _createTextVNode(" Improve your match "),
            _createElementVNode("i", { class: "lnr-pencil" }, null, -1 /* HOISTED */)
          ]), 2 /* CLASS */))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ScoreGradientCircle, {
            score: _ctx.bestFitScore,
            type: _ctx.scoreTypeGradientCircle
          }, null, 8 /* PROPS */, ["score", "type"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.displayScore) + "!", 1 /* TEXT */),
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.displayScoreText), 1 /* TEXT */),
          (_ctx.showWishlistButton)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "WishlistButton MobileButton",
                "data-study-id": _ctx.studyId,
                "data-button-type": "study_header",
                "data-button-location": "study_banner",
                "data-button-class": "DriverButton Small"
              }, null, 8 /* PROPS */, _hoisted_13))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "DriverButton MobileButton Small Blue",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args)))
              }, _cache[3] || (_cache[3] = [
                _createTextVNode(" Improve your match "),
                _createElementVNode("i", { class: "lnr-pencil" }, null, -1 /* HOISTED */)
              ])))
        ])
      ])
    ])
  ]))
}